var map = {
	"./ferizaj.png": 8947,
	"./gjakove.png": 2137,
	"./gjilan.png": 1439,
	"./mitrovica.png": 2188,
	"./pa.png": 3259,
	"./peje.png": 4396,
	"./prishtina.png": 8940,
	"./prizren.png": 9118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7112;